import request from "root/js/request";

const getEvents = async ({ wb_api_key_id }) => {
  const response = await request({
    url: "/analytics/events/",
    method: "get",
    params: {
      wb_api_key_id,
    },
  });
  return response.data;
};
const createEvent = async ({ cabinet_id, name, date, is_regular, is_active }) => {
  const response = await request({
    url: "/analytics/events/",
    method: "post",
    data: {
      cabinet_id,
      date,
      name,
      is_regular,
      is_active,
    },
  });
  return response.data;
};

const updateEvent = async ({ ID, name, date, is_regular, is_active }) => {
  const response = await request({
    url: `/analytics/events/${ID}/`,
    method: "patch",
    data: {
      date,
      name,
      is_regular,
      is_active,
    },
  });
  return response.data;
};

const deleteEvent = async ({ ID }) => {
  const response = await request({
    url: `/analytics/events/${ID}/`,
    method: "delete",
  });
  return response.data;
};

export { getEvents, createEvent, updateEvent, deleteEvent };
